import { render, staticRenderFns } from "./clinic.vue?vue&type=template&id=47d4e5e4&scoped=true&"
import script from "./clinic.vue?vue&type=script&lang=js&"
export * from "./clinic.vue?vue&type=script&lang=js&"
import style0 from "./clinic.vue?vue&type=style&index=0&id=47d4e5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.5_@vue+compiler-sfc@3.5.44_babel-core@7.0.0-bridge.0_@babel+core@7.12.8_bab05b83ea19148beb1746204d3ff44c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4e5e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d4e5e4')) {
      api.createRecord('47d4e5e4', component.options)
    } else {
      api.reload('47d4e5e4', component.options)
    }
    module.hot.accept("./clinic.vue?vue&type=template&id=47d4e5e4&scoped=true&", function () {
      api.rerender('47d4e5e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/clinic.vue"
export default component.exports